module.exports = __webpack_public_path__ + "img/measure-icon-recall.1d744130.png";